/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_CreatingInputs */

const vi_cdo_creating = /** @type {(inputs: Cdo_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tạo…`)
};

/**

* @param {Cdo_CreatingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_creating = /** @type {((inputs?: Cdo_CreatingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_CreatingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_creating(inputs)
});